import React, { Component } from 'react'
import _ from 'lodash'
import { inject, observer } from 'mobx-react'
import styled, { keyframes } from 'styled-components'
import { TweenMax } from 'gsap'
import CheckIcon from '@/assets/images/play-resolved.svg'
import DDStar from '@/Components/CommandHost/Common/DDStar'
import DDSponsorBrand from '@/Components/CommandHost/Common/DDSponsorBrand'
import { vhToPx, evalImage } from '@/utils'
import { intercept, extendObservable, observe } from 'mobx'
import DDAnnounceSponsor from '@/Components/CommandHost/Common/DDAnnounceSponsor'
import { responsiveDimension } from '../../utils'

const PlayColors = {
  liveplay: '#c61818',
  gamemaster: '#19d1bf',
  sponsor: '#495bdb',
  prize: '#9368aa',
}

@inject(
  'CommandHostStore',
  'GameStore',
  'AutomationStore',
  'PrePlayStore',
  'CommonStore'
)
@observer
export default class PlayItemResolved extends Component {
  constructor(props) {
    super(props)
    this.state = {
      reusedPlay: null,
      reusedNewPlayIndex: -1,
      isOpinionQuestion: false,
      isCancelledPlay: false,
    }
    extendObservable(this, {
      sessionStarted: this.props.GameStore.isSessionStarted,
    })
    FONT_SIZE = this.props.CommandHostStore.fontSize + 'vh'

    this.reference = `play-item-resolved-${this.props.item.id}`
    this.MAIN_CHOICE = this.props.item.multiplierChoices.filter(
      o => o.id == this.props.item.id
    )[0]

    this.destroySessionMode = intercept(
      this.props.GameStore,
      'sessionMode',
      change => {
        this.sessionStarted = change.newValue === 1
        this.forceUpdate()
        return change
      }
    )
    this.disposeReuse = observe(this.props.GameStore, 'reusedPlay', change => {
      if (change.newValue) {
        setTimeout(() => {
          this.setState({ reusedPlay: change.newValue })
        }, 0)
      }
      return change
    })
    this.disposeReusedUniqueId = observe(
      this.props.GameStore,
      'reusedUniqueId',
      change => {
        if (change.newValue) {
          setTimeout(() => {
            this.setState({ reusedUniqueId: change.newValue })
          }, 0)
        }
        return change
      }
    )
    this.disposeReusePlayIndex = observe(
      this.props.PrePlayStore,
      'preplayItems',
      change => {
        if (change.newValue) {
          setTimeout(() => {
            this.setState({ reusedNewPlayIndex: change.newValue })
          }, 0)
        }
        return change
      }
    )
  }

  getdisplayAwards(item) {
    var statData = this.props.CommonStore.displayAwards(
      item,
      'PlayItemUnresolved'
    )
    const playStats = this.props.GameStore.playStats
    var toBedisplayedStats = _.filter(playStats, {
      gameplay_id: item.gamePlayId,
    })
    toBedisplayedStats =
      toBedisplayedStats && toBedisplayedStats.length === 1
        ? toBedisplayedStats[0]
        : _.find(toBedisplayedStats, function(tmp) {
            return tmp.stage === 'resolve'
          })
    if (toBedisplayedStats) {
      statData.TokensPlaced = toBedisplayedStats.spent
        ? toBedisplayedStats.spent
        : 0
      statData.BottomPoints =
        toBedisplayedStats.earned && toBedisplayedStats.earned.p
          ? toBedisplayedStats.earned.p
          : 0
      statData.BottomStars =
        toBedisplayedStats.earned && toBedisplayedStats.earned.s
          ? toBedisplayedStats.earned.s
          : 0
      statData.BottomTokens =
        toBedisplayedStats.earned && toBedisplayedStats.earned.t
          ? toBedisplayedStats.earned.t
          : 0
    }
    const textColor =
      (item.type || '').toLowerCase() === 'gamemaster' ? '#f1ecec' : '#d1cbcb'
    return (
      <div
        style={{
          fontSize: 'small',
          display: 'flex',
          justifyContent: 'center',
          height: '100%',
          flexDirection: 'column',
        }}
      >
        <AwardsWrapper style={{ justifyContent: 'space-between' }}>
          <div>
            <AwardHeader color={textColor}>PTS:</AwardHeader>
            <AwardValue>{statData.points || 0}</AwardValue>
            <VerticalDivider>|</VerticalDivider>
            <AwardHeader color={textColor}>TKNS:</AwardHeader>
            <AwardValue>{statData.tokens || 0}</AwardValue>
          </div>
          <div>
            <AwardHeader color={textColor}>TKNS PLACED:</AwardHeader>
            <AwardValue>{statData.TokensPlaced || 0}</AwardValue>
          </div>
          {/* <span>{`PTS: ${statData.points || 0 }`} | {`TKNS: ${statData.tokens || 0}`}</span>
          <span>{`TKNS PLACED: ${statData.TokensPlaced || 0}`}</span> */}
        </AwardsWrapper>
        <div>
          <AwardsWrapper>
            <div>
              <AwardHeader color={textColor}>PTS:</AwardHeader>
              <AwardValue>{statData.BottomPoints || 0}</AwardValue>
            </div>
            <VerticalDivider>|</VerticalDivider>
            <div>
              <AwardHeader color={textColor}>STARS:</AwardHeader>
              <AwardValue>{statData.BottomStars || 0}</AwardValue>
            </div>
            <VerticalDivider>|</VerticalDivider>
            <div>
              <AwardHeader color={textColor}>TKNS:</AwardHeader>
              <AwardValue>{statData.BottomTokens || 0}</AwardValue>
            </div>
          </AwardsWrapper>
          {/* <span>{`PTS: ${statData.points || 0}`} | {`TKNS: ${statData.tokens || 0}`} | {`TKNS: ${statData.tokens || 0}`}</span> */}
        </div>
      </div>
    )
  }

  getPlayAnalytics(item) {
    console.log(`------------------getPlayAnalytics---------------------`)
    const playStats = this.props.GameStore.playStats
    const isOpinionPlay =
      item.pmetadata &&
      item.pmetadata.public &&
      item.pmetadata.public.opinionQuestion
    var filteredPlaystats = _.filter(playStats, {
      gameplay_id: item.gamePlayId,
    })

    var playStatsNoReference = [...filteredPlaystats]
    var toBeDisplayedStats =
      playStatsNoReference.length > 1
        ? _.find(playStatsNoReference, function(tmp) {
            return tmp.stage === 'resolve'
          })
        : playStatsNoReference[0]
    let connected = 0
    if (playStatsNoReference.length > 1) {
      let previousStageStats = _.find(playStatsNoReference, function(tmp) {
        return tmp.stage != 'resolve'
      })
      if (previousStageStats)
        connected =
          previousStageStats.played + previousStageStats.played_tmp >
          previousStageStats.connected
            ? previousStageStats.played + previousStageStats.played_tmp
            : previousStageStats.connected
    } else {
      if (toBeDisplayedStats)
        connected =
          toBeDisplayedStats.played + toBeDisplayedStats.played_tmp >
          toBeDisplayedStats.connected
            ? toBeDisplayedStats.played + toBeDisplayedStats.played_tmp
            : toBeDisplayedStats.connected
    }
    var analyticsData = { TotalPlayers: 0, Missed: 0, Correct: 0, Incorrect: 0 }
    analyticsData.TotalPlayers = connected
    if (toBeDisplayedStats) {
      analyticsData.Missed =
        connected - toBeDisplayedStats.played - toBeDisplayedStats.played_tmp
      analyticsData.Correct =
        connected && isOpinionPlay
          ? connected - analyticsData.Missed
          : toBeDisplayedStats
          ? toBeDisplayedStats.won + toBeDisplayedStats.won_tmp
          : 0
      analyticsData.Incorrect = isOpinionPlay
        ? 0
        : connected * item.result.correctAnswers.length -
          toBeDisplayedStats.won -
          toBeDisplayedStats.won_tmp
    }

    return (
      <PlayAnalyticsWrapper>
        <AwardsWrapper style={{ justifyContent: 'space-between' }}>
          <div style={{ width: '50%', maxWidth: '50%' }}>
            <AwardHeader color="#524f4f">PLAYERS:</AwardHeader>
            <AwardValue style={{ color: '#65ca9a' }}>
              {analyticsData.TotalPlayers || 0}
            </AwardValue>
          </div>
          <div style={{ width: '50%', maxWidth: '50%' }}>
            <AwardHeader color="#524f4f">CORRECT:</AwardHeader>
            <AwardValue style={{ color: '#000', paddingLeft: '9px' }}>
              {analyticsData.Correct || 0}
            </AwardValue>
            <AwardValuePercentage style={{ color: '#6778e2' }}>
              {analyticsData.Correct === 0
                ? `0%`
                : `${this.getAwardValuePercentage(
                    {
                      correct: true,
                      toBeDisplayedStats: toBeDisplayedStats,
                      item: item,
                      analyticsData: analyticsData,
                    },
                    isOpinionPlay
                  ) || 0}%`}
            </AwardValuePercentage>
          </div>
        </AwardsWrapper>
        <div>
          <AwardsWrapper>
            <div style={{ width: '50%', maxWidth: '50%' }}>
              <AwardHeader color="#524f4f">MISSED:</AwardHeader>
              <AwardValue style={{ color: '#000' }}>
                {analyticsData.Missed || 0}
              </AwardValue>
              <AwardValuePercentage style={{ color: '#6778e2' }}>
                {analyticsData.Missed === 0
                  ? `0%`
                  : `${this.getAwardValuePercentage({
                      missed: true,
                      toBeDisplayedStats: toBeDisplayedStats,
                      item: item,
                      analyticsData: analyticsData,
                    }) || 0}%`}
              </AwardValuePercentage>
            </div>
            <div style={{ width: '50%', maxWidth: '50%' }}>
              <AwardHeader color="#524f4f">INCORRECT:</AwardHeader>
              <AwardValue style={{ color: '#000' }}>
                {analyticsData.Incorrect || 0}
              </AwardValue>
              <AwardValuePercentage style={{ color: '#6778e2' }}>
                {analyticsData.Incorrect === 0
                  ? `0%`
                  : `${this.getAwardValuePercentage({
                      incorrect: true,
                      toBeDisplayedStats: toBeDisplayedStats,
                      item: item,
                      analyticsData: analyticsData,
                    }) || 0}%`}
              </AwardValuePercentage>
            </div>
          </AwardsWrapper>
        </div>
      </PlayAnalyticsWrapper>
    )
  }

  getAwardValuePercentage(data, isOpinionPlay) {
    if (data && data.toBeDisplayedStats) {
      if (data.missed) {
        return _.round(
          (data.analyticsData.Missed / data.analyticsData.TotalPlayers) * 100
        )
      }
      if (data.correct) {
        return _.round(
          (data.analyticsData.Correct /
            ((isOpinionPlay ? 1 : data.item.result.correctAnswers.length) *
              data.analyticsData.TotalPlayers)) *
            100
        )
      }
      if (data.incorrect) {
        return _.round(
          (data.analyticsData.Incorrect /
            (data.item.result.correctAnswers.length *
              data.analyticsData.TotalPlayers)) *
            100
        )
      }
    }
  }

  getType(type) {
    type = type.toLowerCase()
    return type === 'liveplay'
      ? 'live'
      : type === 'gamemaster'
      ? 'game'
      : type === 'sponsor'
      ? 'spon'
      : type === 'prize'
      ? 'priz'
      : type
  }

  async handleReuseButtonClick(refId) {
    this.props.AutomationStore.addEvent({
      evt: 'click',
      refId: refId,
      wait: 0.5,
      playId: this.props.item.id,
    })
    //this.props.reuse(this.props.item)
    // document.body.scrollTop = 0
    // document.documentElement.scrollTop = 0

    let { item } = this.props //tmp to delete

    /* //tmp to delete
    const preItemsByType = this.props.PrePlayStore.getPresetItemsByType(
      item.type
    )
    if (!preItemsByType || !preItemsByType.length) return
//console.log('preItemsByType', preItemsByType) //tmp to delete
    //const preItemSelected = await preItemsByType.filter(
      //o => o.preset.toLowerCase() === item.presetId.toLowerCase()
    //)[0]
    const preItemSelected = (item.preset && Object.keys(item.preset).length) ? item.preset : preItemsByType[0]
console.log('item, preItemSelected', item, preItemSelected) //tmp

    const preItemsSelected = preItemSelected ? await this.props.PrePlayStore.pullMultiplierChoices(
      preItemSelected.id
    ) : []
    const _multiplierChoices = []

    if (preItemSelected) {
      _multiplierChoices.push(preItemSelected)
    }

    if (preItemSelected && preItemSelected.choices) {
      for (let i = 0; i < preItemSelected.choices.length; i++) {
        const choice = preItemSelected.choices[i]
        if (choice.nextId) {
          const p_item = preItemsByType.filter(
            o => o.id === choice.nextId
          )[0]
          if (p_item) {
            _multiplierChoices.push(p_item)
          }
        }
      }
    }
    */
    let choices = []
    if (item && item.choices) {
      // filter unique objects based on 'sequence'
      choices = _.reduce(
        item.choices,
        (accumulator, obj) => {
          if ('sequence' in obj) {
            // Check if an object with the same 'sequence' already exists in the accumulator
            const existingObj = _.find(accumulator, { sequence: obj.sequence })
            if (!existingObj) {
              // If not, add it to the accumulator
              accumulator.push(obj)
            }
          } else {
            // Include objects without 'sequence' in the result
            accumulator.push(obj)
          }
          return accumulator
        },
        []
      )
    }
    const pmetadata =
      item && item.pmetadata
        ? {
            timerInput: item.pmetadata.timerInput,
          }
        : {}
    const reusePlay = {
      id: item.id,
      type: item.type,
      playTitle: item.playTitle && item.playTitle.value ? item.playTitle : '',
      choices: JSON.parse(JSON.stringify(item.choices || [])), //preItemSelected ? preItemSelected.choices : [], //tmp to delete
      multiplierChoices: JSON.parse(JSON.stringify(item.multiplierChoices)), //preItemsSelected, //tmp to delete
      stars: item.stars,
      award: await this.props.PrePlayStore.AwardList[item.type],
      backgroundImage: item.backgroundImage,
      preset_n_id: item.preset_n_id,
      pmetadata: pmetadata,
      showNextPlayAd: false,
      nextPlayType: null,
      isPresetTeamChoice: false,
      lockedReuse: false,
      starMax: item.starMax,
      currencyFixed: item.currencyFixed || '',
      points: item.points,
      tokens: item.tokens,
      participantId: item.participantId,
      presetId: item.presetId,
      sponsor: item.sponsor,
      sponsorId: item.sponsorId,
      team: await this.props.GameStore.participants.filter(
        o => o.id === item.part
      )[0],
      preset: JSON.parse(JSON.stringify(item.preset)), //preItemSelected, //tmp to delete
    }

    this.props.reuse(reusePlay)
  }

  resetSuccessReUseState() {
    setTimeout(() => {
      this.setState({ reusedPlay: null })
      this.props.GameStore.reusedPlay = null
    }, 2000)
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.reusedPlay !== nextState.reusedPlay) return true

    if (this.state.reusedNewPlayIndex !== nextState.reusedNewPlayIndex)
      return true

    if (this.state.isOpinionQuestion !== nextState.isOpinionQuestion)
      return true
    if (this.state.isCancelledPlay !== nextState.isCancelledPlay) return true

    return false
  }

  componentWillUnmount() {
    this.destroySessionMode()
    this.disposeReuse()
    this.disposeReusedUniqueId()
    this.disposeReusePlayIndex()
  }

  componentDidMount() {
    if (this.props.item) {
      delete this.props.item.editorEvents
      const questionInputCont = document.getElementById(
        `play_item_resolved_question_input_locked_${this.props.item.sequence}`
      )
      if (questionInputCont) {
        this.scrollHeight = questionInputCont.scrollHeight || 0
        this.clientHeight = questionInputCont.clientHeight || 0
      }
      if (this.props.item.pmetadata && this.props.item.pmetadata.public) {
        const publicData = this.props.item.pmetadata.public
        this.setState({
          isOpinionQuestion: publicData.opinionQuestion,
          isCancelledPlay: publicData.isCancelledPlay,
        })
      }
      this.forceUpdate()
    }
  }

  render() {
    const automationReuseButtonId = `play-item-resolved-reuse-button-${this.props.item.id}`

    let { item } = this.props
    if (!item) return null
    const bg = PlayColors[item.type.toLowerCase()]

    const isLocked = !this.sessionStarted
    const editorReadOnly3Announce = `editor-readonly-3-Announce-${this.props.AutomationStore.playSequence}`
    const { isOpinionQuestion, isCancelledPlay } = this.state
    if (item) {
      setTimeout(() => {
        item.lockedReuse = false
      }, 0)
      return (
        <Container>
          <Wrapper>
            <ResolvedIcon />
            <PlayTypeDD>
              <PrePlaySequence
                backgroundColor={PlayColors[item.type.toLowerCase()]}
                text={`${item.sequence}`}
              />
              <PlayType backgroundColor={PlayColors[item.type.toLowerCase()]}>
                <span>{`${this.getType(item.type)}`}</span>
                {isOpinionQuestion && !isCancelledPlay && (
                  <TextButton
                    name="opn"
                    color={'#000'}
                    backgroundColor={'#EFDF18'}
                    width={1.7}
                    height={1.2}
                  >
                    {'OPN'}
                  </TextButton>
                )}
              </PlayType>
            </PlayTypeDD>
            <SelectTypeLocked title={this.MAIN_CHOICE.preset}>
              {this.MAIN_CHOICE.preset}
            </SelectTypeLocked>
            <QuestionInputLocked
              id={`play_item_resolved_question_input_locked_${item.sequence}`}
              style={{
                alignItems:
                  this.scrollHeight - this.clientHeight > 5
                    ? 'flex-start'
                    : 'center',
              }}
            >
              {this.MAIN_CHOICE.question}
            </QuestionInputLocked>
            <Result>{item.result.resultTitle}</Result>
            <StarWrapper>
              <DDStar
                locked
                item={item}
                height={h}
                index={'playitemresolved-' + item.index}
                value={val => {
                  this.props.item.stars = val
                }}
              />
            </StarWrapper>
            <AwardsDisplay backgroundColor={bg}>
              {this.getdisplayAwards(item)}
            </AwardsDisplay>
            {/* <SponsorBrandWrapper>
              <DDSponsorBrand
                locked
                height={h}
                index={'playitemresolved-' + item.index}
                selectedSponsor={item.sponsor}
                value={val => {
                  item.sponsor = val
                }}
              />
            </SponsorBrandWrapper> */}
            {this.getPlayAnalytics(item)}
            <ButtonGroup>
              <DDSponsorWrapper
                className={`${this.reference}-sponsor`}
                style={{
                  display: 'block',
                  marginLeft: '0.2vh',
                }}
              >
                <DDAnnounceSponsor
                  locked
                  height={h}
                  index={`${this.reference}-sponsor`}
                  selectedSponsor={null}
                  // value={this.handleSelectedSponsor.bind(this)}
                  expanded={item.sponsorExpanded}
                  forId={editorReadOnly3Announce}
                  PlayStoreSample={this.props.PrePlayStore}
                  subType={item ? item.subType : null}
                  sponsorId={item.sponsorId}
                  playStackFromUnresolved={true}
                  fromStack="PLAY_ITEM"
                  sponsorMetaData={
                    item.sponsor ? item.sponsor.sponsorItem || null : null
                  }
                  pmetadata={
                    item.pmetadata ? item.pmetadata.public || null : null
                  }
                />
              </DDSponsorWrapper>
              <ReuseButton
                locked={isLocked}
                id={automationReuseButtonId}
                onClick={
                  isLocked
                    ? null
                    : this.handleReuseButtonClick.bind(
                        this,
                        automationReuseButtonId
                      )
                }
              >
                {this.state.reusedPlay === item.id &&
                  this.state.reusedNewPlayIndex !== -1 && (
                    <ReUseSuccess
                      onAnimationEnd={e => {
                        e.stopPropagation()
                        this.resetSuccessReUseState()
                      }}
                    >
                      {'success'}
                    </ReUseSuccess>
                  )}
              </ReuseButton>
            </ButtonGroup>
          </Wrapper>
        </Container>
      )
    } else {
      return <Container />
    }
  }
}

const h = 6
let FONT_SIZE = '1.8vh'

const AwardsDisplay = styled.div`
  background-color: ${props => props.backgroundColor};
  color: white;
  height: 100%;
  padding-left: 2px;
  padding-right: 2px;
  font-family: pamainregular;
  min-width: 16%;
  max-width: 16%;
`

const Container = styled.div`
  width: 100%;
  height: ${props => h}vh;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
  opacity: 0;
  animation: ${props => fadeIn} 0.5s forwards;
  margin-top: ${props => 0.2}vh;
`
const fadeIn = keyframes`
  0%{opacity: 0;}
  100%{opacity: 1}
`

const Wrapper = styled.div`
  width: inherit;
  height: inherit;
  display: flex;
  flex-direction: row;
  user-select: text;
`

const ResolvedIcon = styled.div`
  width: 3.5%;
  height: inherit;
  background-color: #000000;
  &:after {
    width: 100%;
    height: 100%;
    content: '';
    display: inline-block;
    background-image: url(${CheckIcon});
    background-repeat: no-repeat;
    background-size: 50%;
    background-position: center;
  }
`
const PlayTypeDD = styled.div`
  width: 10%;
  height: ${props => h}vh;
  display: flex;
`

const PrePlaySequence = styled.div`
  width: 40%;
  height: ${props => h}vh;
  background-color: ${props => props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainlight;
  font-size: ${props => FONT_SIZE};
  color: white;
  line-height: 1;
  border-right: 0.5px solid;
  &:after {
    content: '${props => props.text}';
  }
`

const PlayType = styled.div`
  width: 60%;
  height: inherit;
  background-color: ${props => props.backgroundColor};
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
`

const TextButton = styled.div`
  position: absolute;
  left: 9.9%;
  padding-top: 0.1%;
  width: ${props => responsiveDimension(props.width || 2)};
  height: ${props => responsiveDimension(props.height || 2)};
  color: ${props => props.color || '#fff'};
  background-color: ${props => props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainregular;
  font-size: ${props => responsiveDimension(0.7)};
  border: ${responsiveDimension(0.2)} solid #000;
  opacity: ${props => (props.isDisabled ? 0 : '')};
  pointer-events: ${props => (props.isDisabled ? 'none' : '')};
`

const SelectTypeLocked = styled.div`
  width: 7%;
  height: ${props => h}vh;
  background-color: #e5e5e5;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
  color: #000000;
  text-transform: uppercase;
  display: block;
  text-align: center;
  line-height: ${props => h}vh;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 0.5vh;
`

const QuestionInputLocked = styled.div`
  width: 20%;
  height: inherit;
  font-family: pamainbold;
  font-size: ${props => 1.4}vh;
  text-transform: uppercase;
  // text-indent: ${props => 1}vh;
  background-color: #ffffff;
  display: flex;
  align-items: flex-start;
  padding-left: 1vh;
  overflow: auto;
  ms-overflow-style: ${'-ms-autohiding-scrollbar'};
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0.3vh rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
    border-radius: ${props => 1}vh;
  }
  &::-webkit-scrollbar {
    width: ${props => responsiveDimension(0.4)};
    background-color: #f5f5f5;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 0, 0, 0.6);
    &:hover {
      background-color: rgba(255, 0, 0, 1);
    }
    border-radius: ${props => 1}vh;
  }
  line-height: 1.6;
`

const Result = styled.div`
  width: 20%;
  height: inherit;
  background-color: #0fbc1c;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  font-size: ${props => 1.4}vh;
  padding: 0 0.4%;
`

const StarWrapper = styled.div`
  width: 3%;
  height: ${props => h}vh;
`

const SponsorBrandWrapper = styled.div`
  width: 13%;
  height: ${props => h}vh;
`

const PlayAnalyticsButton = styled.div`
  width: 28%;
  height: inherit;
  color: ${props => props.color || '#c61818'};
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:after {
    content: 'PLAY ANALYTICS';
  }
`
const ButtonGroup = styled.div`
  width: 15%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  background-color: #eaeaea;
`

const ReuseButton = styled.div`
  width: 40%;
  height: inherit;
  color: #18c5ff;
  background-color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  opacity: ${props => (props.locked ? 0.2 : 1)};
  &:before {
    content: 'REUSE';
    width: 70%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &:after {
    width: 20%;
    height: 100%;
    content: '';
    background-image: url(${props => evalImage('reuse.svg')});
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
  }
`

const ReUseSuccess = styled.div`
  width: 5.1%;
  height: ${h}vh;
  color: #fff;
  background-color: #0fbc1c;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  position: absolute;
  z-index: 101;
  animation: ${props => `${slideIn} 2s forwards`};
`

const slideIn = keyframes`
  0% { transform: translateX(100%); opacity: 0; }
  100% { 
    transform: translateX(0%); 
    opacity: 1;
  }
`

const AwardHeader = styled.span`
  color: ${props => props.color || '#ccc'};
  margin-right: 0px;
  font-size: 1.4vh;
`

const AwardValue = styled.span`
  color: #fff;
  font-size: medium;
`

const AwardValuePercentage = styled.span`
  font-size: medium;
  color: #6778e2;
  padding-left: 3px;
`

const AwardsWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 8px;
  justify-content: space-between;
`
const VerticalDivider = styled.span`
  color: #ccc;
  margin: 0 4px;
`

const PlayAnalyticsWrapper = styled.div`
  font-size: small;
  display: flex;
  justify-content: center;
  height: 100%;
  flex-direction: column;
  background-color: #ffffff;
  min-width: 17%;
  max-width: 17%;
`

const DDSponsorWrapper = styled.div`
  width: 60%;
  position: relative;
  display: none;
  background-repeat: no-repeat;
  background-position: bottom -0.4vh right;
  background-size: 1.4vh;
  background-image: url(/static/media/preplay-up-arrow-black.86e9a30f.svg);
`



// WEBPACK FOOTER //
// src/Components/CommandHost/PlayItemResolved.js